export default __webpack_public_path__ + "static/retreival-35b7cae4f70c34d8380695e15a0f56a6.jpg";